/* @ngInject */
const myDispatchCreateForm = (
  toaster,
  $$dispatch
) => {
  return {
    restrict: 'E',
    scope: {
      myDispatch: '=',
      enableTitle: '=?',
      enableBack: '=?',
    },
    template: require('./myDispatchCreateForm.html'),

    /* @ngInject */
    controller: ($scope) => {
      $scope.saveDispatch = async (_dispatch) => {
        try {
          const formattedDispatch = $$dispatch.format.server(_dispatch)
          const response = await $$dispatch.request.save(formattedDispatch)
          toaster.message(response.message)
          $scope.myDispatch = $$dispatch.new.classic()
          $scope.createDispatchForm.$setPristine()
          $scope.createDispatchForm.$setUntouched()
        } catch (error) {
          toaster.error(error)
        }
      }

      $scope.setClef = () => {
        $scope.myDispatch.comment = "Autorisation clef"
      }
      $scope.setDerangement = () => {
        $scope.myDispatch.comment = "PN en dérangement"
      }
      $scope.setGardiennage = () => {
        $scope.myDispatch.comment = "Gardiennage PN"
      }
      $scope.setRetour = () => {
        $scope.myDispatch.comment = "Retour à la normale"
      }
      $scope.setBening = () => {
        $scope.myDispatch.comment = "SGM --> AIGUILLEUR POSTE 1 BENING\nJ'autorise l'engagement de la Voie … par le train N° …"
      }
    },
    link: {
      pre: (scope, element, attrs) => {

        scope.myDispatch = $$dispatch.new.classic()
      },
      post: (scope, element, attrs, ctrl) => {

      },
    },
  }
}

export default myDispatchCreateForm



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/dispatch/directives/forms/myDispatchCreateForm.js